import {memo, ReactNode} from 'react';

import styled from 'styled-components';

import PieButton from '~/shared/theme/pie/PieButton';
import {bodyBold} from '~/shared/theme/typography';
import {flipOnLTR} from '~/shared/theme/utils';
import {FlexCenter} from '~/shared/theme/FlexLayout';

const StyledPieButton = styled(PieButton).attrs({
  variant: 'outlineLarge',
})`
  width: 100%;

  .button-content-container {
    width: 100%;
  }
`;

const Wrapper = styled.p`
  ${bodyBold}
  color: ${({theme}) => theme.colors.contentDefault};
  position: relative;
  text-align: center;
  width: 100%;
`;

const IconWrapper = styled(FlexCenter)`
  position: absolute;
  top: 1px;
  width: 21px;
  height: 21px;
  ${flipOnLTR`
    right: 0;
  `}
`;

type AuthProviderButtonProps = {
  icon: ReactNode;
  className?: string;
  text: string;
  ariaLabel?: string;
  onClick?: () => void;
};

const AuthProviderButton = ({className, text, icon, ariaLabel, onClick}: AuthProviderButtonProps) => {
  return (
    <StyledPieButton className={className} aria-label={ariaLabel} onClick={onClick}>
      <Wrapper>
        {text}
        <IconWrapper>
          {icon}
        </IconWrapper>
      </Wrapper>
    </StyledPieButton>
  );
};

export default memo(AuthProviderButton);
